import store from '@/store'
import router from '@/router'
import { getSearchTextInputOfSearchUIParam, getIsFuzzyInputOfSearchUIParam } from '@/util/search-ui'

/**
 * 検索テキストを取得する
 * @param {*} searchCategory 
 * @returns 
 */
export const getSearchText = (searchCategory) => {
  return getSearchTextInputOfSearchUIParam(searchCategory)
}

/**
 * 曖昧フラグを取得する
 * @param {*} searchCategory 
 * @returns 
 */
export const getIsFuzzy = (searchCategory) => {
  return getIsFuzzyInputOfSearchUIParam(searchCategory)
}

/**
 * 検索カテゴリ名を取得
 * @param {*} searchCategory 
 * @returns 
 */
export const getSearchCategoryName = (searchCategory) => {
  let label = ''
  switch (searchCategory) {
    case 'qa':
      label = 'Q&A・事例'
      break
    case 'knowledge':
      label = '最新ナレッジ'
      break
    case 'book':
      label = '書籍目次'
      break
    case 'download':
      label = '書式ダウンロード'
      break
    case 'note':
      label = 'ノート'
      break
  }
  return label
}

/**
 * 検索ボタン＆検索フォームのGA用classを取得
 * @param {*} screenType 
 * @param {*} searchCategory 
 */
export const getGASearchClass = (screenType, searchCategory) => {
  if (screenType === 'dashboard') {
    // ダッシュボード画面の場合
    if (searchCategory === 'qa') {
      return 'ga-search-dashboard-qa'
    } else if (searchCategory === 'knowledge') {
      return 'ga-search-dashboard-knowledge'
    } else if (searchCategory === 'book') {
      return 'ga-search-dashboard-book-list'
    } else if (searchCategory === 'download') {
      return 'ga-search-dashboard-document-downloads-list'
    } else if (searchCategory === 'note') {
      return 'ga-search-dashboard-note'
    } else {
      return ''
    }
  } else if (screenType === 'menu') {
    // メニューの場合
    if (searchCategory === 'qa') {
      return 'ga-search-menu-qa'
    } else if (searchCategory === 'knowledge') {
      return 'ga-search-menu-knowledge'
    } else if (searchCategory === 'book') {
      return 'ga-search-menu-book-list'
    } else if (searchCategory === 'download') {
      return 'ga-search-menu-document-downloads-list'
    } else if (searchCategory === 'note') {
      return 'ga-search-menu-note'
    } else {
      return ''
    }
  } else {
    // QA一覧画面、書籍一覧画面、書式ダウンロード一覧画面、最新ナレッジ一覧画面、ノート一覧画面の場合
    // 画面関係なく選択した検索カテゴリによりGAクラス名を決定する
    if (searchCategory === 'qa') {
      return 'ga-search-qa'
    } else if (searchCategory === 'knowledge') {
      return 'ga-search-knowledge'
    } else if (searchCategory === 'book') {
      return 'ga-search-book-list'
    } else if (searchCategory === 'download') {
      return 'ga-search-document-downloads-list'
    } else if (searchCategory === 'note') {
      return 'ga-search-note'
    } else {
      return ''
    }
  }
}

/**
 * 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
 * @param {object} context
 * @param {string} searchCategory 検索対象
 * @param {string} keyword 検索キーワード
 * @param {number} isFuzzy 表記の揺れを含む 0=含まない、1=含む
 */
export const searchByKeyword = (context, searchCategory, keyword, isFuzzy) => {

  const { currentRoute } = router

  // ### 遷移前の初期化処理 ###
  if (store.state.common.device === 'sp') {
    if (searchCategory === 'book') {
      // 書籍一覧画面遷移用の初期化
      // 表示中の目次のノードIDをリセット → 書籍目次画面のトップが表示される
      store.dispatch('bookList/setTargetNodeIdOfTableOfContents', 0)

      // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
      store.dispatch('bookList/setMainListType', 'book')
    }
  }
  // 詳細検索フラグをリセットする
  store.dispatch('qa/setSearchDetail', false)

  // ### メイン処理 ###
  switch (searchCategory) {
    case 'qa': {
      const searchParams = {
        search_text: keyword,
        is_fuzzy: isFuzzy
      }
      const nextRoute = store.state.common.device === 'sp' ? 'SPQAList' : 'PCQAList'
      store.dispatch('search/setQASearchExtractParam', searchParams)
      store
        .dispatch('search/setQASearchParam', searchParams)
        .then(() => {

          // 絞り込みエリアの検索条件をクリア
          store.dispatch('qa/setIdMapListOfCheckedBooks', [])

          if (currentRoute.name === nextRoute) {
            context.emit('searchByKeyword')
            context.emit('closeMenu')
          } else {
            router.push({ name: nextRoute })
          }
        })
      break
    }
    case 'knowledge': {
      const searchParams = {
        keyword: keyword,
        is_fuzzy: isFuzzy
      }
      const nextRoute = store.state.common.device === 'sp' ? 'SPKnowledgeList' : 'PCKnowledgeList'
      store
        .dispatch('search/setKnowledgeSearchParam', searchParams)
        .then(() => {
          if (currentRoute.name === nextRoute) {
            context.emit('searchByKeyword')
            context.emit('closeMenu')
          } else {
            router.push({ name: nextRoute })
          }
        })
      break
    }
    case 'book': {
      const searchParams = {
        search_text: keyword,
        is_fuzzy: isFuzzy
      }
      const nextRoute = store.state.common.device === 'sp' ? 'SPBookList' : 'PCBookList'
      store
        .dispatch('search/setBookSearchParam', searchParams)
        .then(() => {

          // 絞り込みエリアの検索条件をクリア
          store.dispatch('bookList/setIdMapListOfCheckedProducts', [])
          store.dispatch('bookList/setPackagesAndProductsAreaTreeData', {})
          store.dispatch('bookList/setPackagesAndProductsAreaBooks', [])

          if (currentRoute.name === nextRoute) {
            context.emit('searchByKeyword')
            context.emit('closeMenu')
          } else {
            router.push({ name: nextRoute })
          }
        })
      break
    }
    case 'download': {
      // 書式DLは曖昧フラグはない
      const searchParams = {
        search_text: keyword
      }
      const nextRoute = store.state.common.device === 'sp' ? 'SPDocumentDownloadsList' : 'PCDocumentDownloadsList'
      store
        .dispatch('search/setDownloadSearchParam', searchParams)
        .then(() => {

          // 絞り込みエリアの検索条件をクリア
          store.dispatch('documentDownloadsList/setIdMapListOfCheckedProducts', [])
          store.dispatch('documentDownloadsList/setPackagesAndProductsAreaTreeData', {})
          store.dispatch('documentDownloadsList/setPackagesAndProductsAreaBooks', [])

          if (currentRoute.name === nextRoute) {
            context.emit('searchByKeyword')
            context.emit('closeMenu')
          } else {
            router.push({ name: nextRoute })
          }
        })
      break
    }
    case 'note': {
      const searchParams = {
        keyword: keyword,
        is_fuzzy: isFuzzy
      }
      const nextRoute = store.state.common.device === 'sp' ? 'SPNoteList' : 'PCNoteList'
      store
        .dispatch('search/setNoteSearchParam', searchParams)
        .then(() => {
          if (currentRoute.name === nextRoute) {
            context.emit('searchByKeyword')
            context.emit('closeMenu')
          } else {
            router.push({ name: nextRoute })
          }
        })
      break
    }
  }
}
